<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="active tab-pane">
                <div id="office">
                    <office-server-table
                        v-if="loaded"
                        :data-url="st.url"
                        :data-columns="JSON.stringify(st.columns)"
                        :preference-url="st.preferenceUrl"
                    ></office-server-table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import OfficeServerTable from "../../../components/CRM/OfficeServerTable";
import axios from "axios";

export default {

    components: {
        OfficeServerTable,
    },

    data() {
        return {
            loaded:false,
            st: {
                columns:[],
                url:'',
                preferenceUrl:'',
            }
        }
    },

    metaInfo: {
        title:'Alle collega\'s',
    },

    methods: {
        getOfficeData() {
            axios.get(this.route('api.v1.crm.contacts.office.st'))
            .then(resp => {
                this.st = resp.data;
                this.loaded = true;
            })
        }
    },

    mounted() {
        this.getOfficeData();
    },

    name:'CrmOfficeIndex',

}

</script>
